import './onboarding-loader.scss';
import { ActivityIndicator } from '../../../components/common/activity-indicator/activity-indicator';

export const OnboardingLoader = () => {
    return (
        <>
            <div className="loader--wrap">
                <ActivityIndicator />
            </div>
            <div className="loader--spacer"></div>
        </>
    );
};
